import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RouterChangeService {
  public counter: BehaviorSubject<number>;

  constructor(private router: Router) {
    this.counter = new BehaviorSubject(0);
    this.router.events.subscribe(event => {
      this.counter.next(this.counter.value + 1);

      if (event instanceof NavigationEnd) {
        window.scrollTo({ top: 0 });
        ga('set', 'page', event.urlAfterRedirects);
        ga('send', 'pageview');
      }
    });
  }
}
